import { ActionBar, Form, FormBuilder } from "@redriver/cinnamon";
import { ListSearch } from "components/lists";
import React from "react";
import { useTranslation } from "react-i18next";
import DocumentAuditTrailFilters from "./DocumentAuditTrailFilters";
import { DealersTypeAheadLookup } from "features/../../../shared/features/Dealers/lookups";
import ExportDocumentAuditTrails from "./ExportDocumentAuditTrails";
import { PermissionCheck } from "features/../../../shared/components/auth";
import {
  Actions,
  Targets,
} from "features/../../../shared/constants/permissions";

const HeaderBar = ({ state, events, onAdded, pageNumber, pageSize }) => {
  const { t } = useTranslation("documentAuditTrails");
  return (
    <FormBuilder
      value={state.filters}
      onChange={events.onChangeFilters}
      renderForm={(formProps) => (
        <Form {...formProps}>
          <ActionBar>
            <ActionBar.Item>
              <DealersTypeAheadLookup
                field="dealerId"
                clearable
                label={t("SelectSuppliers")}
                placeholder={t("SelectSuppliers")}
              />
            </ActionBar.Item>
            <ActionBar.Space />
            <ActionBar.Item fluid>
              <ListSearch
                value={state.filters}
                onChange={events.onChangeFilters}
                label={t("SearchAuditTrail")}
                placeholder={t("Search")}
              />
            </ActionBar.Item>
            <ActionBar.Item align="right">
              <DocumentAuditTrailFilters
                value={state.filters}
                onChange={events.onChangeFilters}
              />
            </ActionBar.Item>
            <PermissionCheck
              target={Targets.Sheet}
              action={Actions.DownloadAuditTrail}
            >
              <ActionBar.Item>
                <ExportDocumentAuditTrails
                  filters={state.filters}
                  pageNumber={pageNumber}
                  pageSize={pageSize}
                />
              </ActionBar.Item>
            </PermissionCheck>
          </ActionBar>
        </Form>
      )}
    />
  );
};

export default HeaderBar;
